import * as destinationPackageService from "../../../../services/destinationPackage";
import * as settings from "../../../../services/settings";

import { Button, Card, Col, Form, Row, Spin, Tabs, Typography, notification } from "antd";
import { useCallback, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { useTranslation } from "react-i18next";
import ContentType from "../../../../../configs/contentType";
import permissions from "../../../../../configs/permission";
import BtnHistory from "../../../../Components/model/button/history";
import { CreateDestinationPackageDetail } from "../../../../Components/package/destinationPackageDetail";
import { useAccessToken } from "../../../../contexts/AccessTokenContext";
import { usePermission } from "../../../../hooks/usePermission";
import { resolveImageUrl } from "../../../../utils/imageUrl";

const { Title } = Typography;
const initPage = { limit: 10, page: 1 };
export const DestinationPackageCreatePage = () => {
  const { hasPermission, isSuperuser } = usePermission();
  const { accessToken } = useAccessToken();
  const [formDestinationPackage] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [isDisable, setIsDisable] = useState(true);
  const [isHiddenBtnCreate, setIsHiddenBtnCreate] = useState(false);
  const [isCheckCreateSuccess, setIsCreateSuccess] = useState(false);
  const { t } = useTranslation("destinationpackage", "buttons");
  const [fileList, setFileList] = useState([]);
  const [dataById, setDataById] = useState(null);

  const location = useLocation();
  const data = location.state;
  const navigation = useNavigate();
  // Validate field is required
  // const [validateFieldRequired, setValidateFieldRequired] = useState({
  //   fieldReference: false,
  //   fieldTracking: false,
  //   fieldRoute: false,
  //   fieldOrigin: false,
  //   fieldDestination: false,
  //   fieldCustomer: false,
  //   fieldPackageType: false,
  //   fieldPackageStatus: false,
  //   fieldTotalCount: false,
  //   fieldLength: false,
  //   fieldHeight: false,
  //   fieldWeight: false,
  //   fieldWeightType: false,
  //   fieldAmount: false,
  // })

  const [api, contextHolder] = notification.useNotification();
  const openNotificationWithIcon = (type, message, description) => {
    api[type]({
      message: message,
      description: description,
    });
  };

  const setDetailData = (data) => {
    formDestinationPackage.setFieldValue("package_description", data.package_description);
    formDestinationPackage.setFieldValue("package_type", data.package_type);
    formDestinationPackage.setFieldValue("package_status", data.package_status);
    formDestinationPackage.setFieldValue("total_count", data.total_count);
    formDestinationPackage.setFieldValue("length", data.length);
    formDestinationPackage.setFieldValue("width", data.width);
    formDestinationPackage.setFieldValue("height", data.height);
    formDestinationPackage.setFieldValue("weight", data.weight);
    formDestinationPackage.setFieldValue("volume", data.volume);
    formDestinationPackage.setFieldValue("weight_type", data.weight_type);
    formDestinationPackage.setFieldValue("amount", data.amount);
    formDestinationPackage.setFieldValue("total_count", data.total_count);
    formDestinationPackage.setFieldValue("total_amount", data.total_amount);
    formDestinationPackage.setFieldValue("total_volume", data.total_volume);
    formDestinationPackage.setFieldValue("total_weight", data.total_weight);
    formDestinationPackage.setFieldValue("total_received", data.total_received);
    if (data && data.app_destinationpackageimage !== undefined) {
      if (data.app_destinationpackageimage.length > 0) {
        let listImages = [];
        data.app_destinationpackageimage.map((value) => {
          let subUidImage = value.image.substring(42, 78);
          let newImages = {
            uid: subUidImage,
            name: `image_${value.id}.png`,
            status: "done",
            url: resolveImageUrl(value.image),
            id: value.id,
          };
          listImages.push(newImages);
        });
        setFileList(listImages);
      }
    }
  };

  const onClickedTab = (data) => {
    if (data !== "1") {
      setIsHiddenBtnCreate(true);
    } else {
      setIsHiddenBtnCreate(false);
    }
  };

  const onSubmit = async () => {
    const values = await formDestinationPackage.getFieldsValue();
    const {
      package_type,
      package_description,
      package_status,
      total_count,
      total_amount,
      total_received,
      total_volume,
      total_weight,
      length,
      width,
      height,
      weight,
      weight_type,
      amount,
      volume,
    } = values || {};

    const fromData = new FormData();
    // Detail
    fromData.append("package_description", package_description);
    fromData.append("package_type", [package_type]);
    fromData.append("package_status", package_status);
    fromData.append("total_count", total_count);
    fromData.append("length", length);
    fromData.append("width", width);
    fromData.append("height", height);
    fromData.append("weight", weight);
    fromData.append("volume", volume);
    fromData.append("weight_type", weight_type);
    fromData.append("amount", amount);
    fromData.append("total_amount", total_amount);
    fromData.append("total_received", total_received);
    fromData.append("total_weight", total_weight);
    fromData.append("total_volume", total_volume);
    const old_images = [];
    if (fileList.length > 0) {
      fileList.map((file) => {
        if (file.id) {
          old_images.push(file.id);
        } else {
          fromData.append("file", file.originFileObj);
        }
      });
      fromData.append("old_images", JSON.stringify(old_images));
    }
    setLoading(true);
    try {
      fromData.append("id", data.destinationPackageData.id);

      const response = await destinationPackageService.updateDestinationPackage(accessToken, fromData);
      if (response !== null || response != undefined) {
        setDetailData(response);
        setLoading(false);
        openNotificationWithIcon(
          settings.NotificationType.SUCCESS,
          <>{"Success."}</>,
          <>{"Update origin package success"}</>
        );
      }
    } catch (err) {
      console.error("[DestinationPackageCreatePage] onSubmit: ", err);
      const { message } = settings.getErrorMessage(err);
      openNotificationWithIcon(settings.NotificationType.ERROR, <>{"ERROR."}</>, <>{`${message}`}</>);
      setLoading(false);
    }
  };

  const fetchDestinationPackageById = useCallback(
    async (param) => {
      setLoading(true);
      try {
        const data = await destinationPackageService.getDestinationPackageById(accessToken, param.id);
        setDetailData(data);
        setDataById(data);
      } catch (err) {
        console.error("[DestinationPackageCreatePage] fetchDestinationPackageById: ", err);
        const { message } = settings.getErrorMessage(err);
        openNotificationWithIcon(settings.NotificationType.ERROR, <>{"ERROR."}</>, <>{`${message}`}</>);
        setLoading(false);
      }
      setLoading(false);
    },
    [accessToken]
  );

  useEffect(() => {
    setLoading(true);
    if (!accessToken) return;
    setLoading(false);
    if (data.type === "EDIT") {
      fetchDestinationPackageById(data.destinationPackageData);
      setIsDisable(false);
      setIsCreateSuccess(false);
    }
  }, [accessToken]);

  /** โหมด EDIT: อนุญาตบันทึกเมื่อแก้ package ได้ หรือมีสิทธิ์จัดการรูป (สอดคล้อง destinationPackageDetail) */
  const canSaveInEditMode =
    hasPermission(permissions.DestinationPackage.CHANGE) ||
    hasPermission(permissions.DestinationPackageImage.ADD) ||
    hasPermission(permissions.DestinationPackageImage.CHANGE) ||
    hasPermission(permissions.DestinationPackageImage.DELETE);

  const initialItems = [
    {
      label: t("Detail_Page.Tab_Detail.Title"),
      children: (
        <CreateDestinationPackageDetail
          t={t}
          type={data.type}
          formDestinationPackage={formDestinationPackage}
          setFileList={setFileList}
          fileList={fileList}
        />
      ),
      key: "1",
    },
    // {
    //   label: t('Origin_Package_Create.Create_Services.Title_Services'),
    //   children: (
    //     <CreateOriginPackageServices
    //       t={t}
    //       type={data.type}
    //       detailData={isCreate ? dataOriginPackage : data.originPackageData}
    //       accessToken={accessToken}
    //     />
    //   ),
    //   key: '2',
    //   disabled: isDisable,
    // },
  ];

  return (
    <>
      {contextHolder}
      <Spin spinning={loading}>
        <Row>
          <Col span={24}>
            <div className="flex justify-between">
              <Title level={2}>{t("Detail_Page.Title")}</Title>
              {data?.type === "EDIT" && (
                <BtnHistory
                  titleRef={dataById?.package_description}
                  object_id={dataById?.id}
                  content_type_id={[ContentType.DestinationPackage, ContentType.DestinationPackageImage]}
                />
              )}
            </div>
          </Col>
        </Row>
        <Row align="middle" justify="center">
          <Col span={24}>
            <Card>
              <Tabs type="card" items={initialItems} onChange={onClickedTab} />
            </Card>
          </Col>
        </Row>
        {isHiddenBtnCreate === false ? (
          <Row align="middle" justify="end" style={{ marginTop: "20px" }}>
            {(data?.type === "CREATE" && hasPermission(permissions.DestinationPackage.ADD)) ||
            (data?.type === "EDIT" && canSaveInEditMode) ? (
              <Button
                type="primary"
                // disabled={
                //   data.type === 'CREATE'
                //     ? validateFieldRequired.fieldPackageType &&
                //       validateFieldRequired.fieldPackageStatus &&
                //       validateFieldRequired.fieldTotalCount &&
                //       validateFieldRequired.fieldLength &&
                //       validateFieldRequired.fieldHeight &&
                //       validateFieldRequired.fieldWeight &&
                //       validateFieldRequired.fieldWeightType &&
                //       validateFieldRequired.fieldAmount
                //       ? isCheckCreateSuccess
                //         ? true
                //         : false
                //       : true
                //     : false
                // }
                onClick={onSubmit}
                style={{ marginRight: "10px" }}
              >
                {t("BTN_Save", { ns: "buttons" })}
              </Button>
            ) : null}
            <Button
              type="default"
              onClick={() => {
                navigation("/package/destinationpackage");
              }}
            >
              {t("BTN_Cancel", { ns: "buttons" })}
            </Button>
          </Row>
        ) : (
          ""
        )}
      </Spin>
    </>
  );
};
